import Joi from '@hapi/joi'

export const DashboardSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select Group`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operation Entity").messages({
        "any.invalid": `Select OperationEntity`,
        "any.required": `OperationEntity required`
    }),
    
}